var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{attrs:{"id":"telegram-login-button"}}),_c('br'),_c('b-button',{on:{"click":_vm.sendMessage}},[_vm._v("send message")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }